export default function transportData(){
    return {
        delivery: {
            'install':'no',
            'installCost':0,
            'option':null,
            'timeSlots': process.env.insideWorkingHours,
            'timeStart':'08:00',
            'timeEnd':'18:00',
            'startReadOnly':true
          },
          collection: {
            'derig':'no',
            'derigCost':0,
            'option':null,
            'timeSlots': process.env.outsideWorkingHours,
            'timeStart':'08:00',
            'timeEnd':'18:00',
          }
    }
}